module.exports = "/wwwroot/img/water_supply_breaks_lift_block.png?ver=7c78fe46";